"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = uniqueID;

var _mathRandom = _interopRequireDefault(require("math-random"));
/* eslint no-magic-numbers: ["error", { "ignore": [2, 36] }] */


function uniqueID() {
  return Date.now() + (0, _mathRandom["default"])().toString(36).substr(2);
}